import {
  IBaseConfig,
  IFormFieldFilter,
  ITable,
} from "@models/form/base-config";
import {
  HardFormFieldTypeEnum,
  HardTableColumnTypeEnum,
  IHardFormField,
  IHardFormInputParams,
} from "@hardcode-kz/ui";

export class BaseConfig implements IBaseConfig {
  version = 1;

  fields: IHardFormField<any>[] = [
    {
      name: "code",
      title: "Код",
      type: HardFormFieldTypeEnum.Input,
    },
    {
      name: "name",
      title: "Наименование",
      type: HardFormFieldTypeEnum.Input,
    },
  ];

  tableConfig?: ITable<any> = {
    showDefaultActions: true,
    tableColumns: "200px 1fr auto",

    columns: [
      {
        type: HardTableColumnTypeEnum.Text,
        title: "Код",
        name: "code",
      },
      {
        type: HardTableColumnTypeEnum.Text,
        title: "Наименование",
        name: "name",
      },
    ],
  };

  filterTemplateColumns = "220px";
  filterFields: IFormFieldFilter<any>[] = [
    {
      type: HardFormFieldTypeEnum.Input,
      name: "searchTerm",
      placeholder: "base.search",
      outside: true,
      params: {
        isAutoFocus: true,
      } as IHardFormInputParams,
    },
  ];
}
